import type { ForwardedRef } from 'react';
import React from 'react';
import { PageActionDiscriminator as getPageActionModelDiscriminator } from 'autogen/swagger/all';
import withAsyncStatus from 'components/hoc/WithAsyncStatus/WithAsyncStatus';
import withSpinner from 'components/hoc/WithSpinner/WithSpinner';
import { withIcon } from 'components/hoc/withIcon/WithIcon';
import type { PageActionProps } from 'components/shared/Routing/PageAction';
import CustomActionButton from './CustomActionButton';
import LinkActionButton from './LinkActionButton';
import type { ButtonProps } from './shared/types/button';

export type PageActionButtonProps = PageActionProps & ButtonProps<HTMLAnchorElement | HTMLButtonElement>;

const PageActionButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, PageActionButtonProps>(
    ({ action, size = 'md', ...restProps }, ref) =>
        getPageActionModelDiscriminator(
            action,
            (customAction) => (
                <CustomActionButton
                    ref={ref as ForwardedRef<HTMLButtonElement>}
                    action={customAction.action}
                    size={size}
                    {...restProps}
                />
            ),
            (linkAction) => (
                <LinkActionButton
                    ref={ref as ForwardedRef<HTMLAnchorElement>}
                    action={linkAction.action}
                    size={size}
                    {...restProps}
                />
            ),
            () => {
                throw new Error('invalid action type');
            }
        )
);

export default Object.assign(PageActionButton, {
    WithIcon: withIcon(PageActionButton),
    WithAsyncStatus: withAsyncStatus(PageActionButton),
    WithSpinner: withSpinner(withAsyncStatus(PageActionButton))
});
